import { Alert, AlertDescription, AlertIcon, Link } from "@chakra-ui/react";
import { useFundFamilyEventDelete } from "gen/endpoints/fund-family-event/fund-family-event";
import React from "react";
import { useTranslation } from "react-i18next";
import { useToast } from "shared/components/toast/useToast";
import { ErrorIcon } from "shared/icons/ErrorIcon";

interface OutOfDateAlertProps {
  fundFamilyId: string;
  fundFamilyEventId: string;
  message: string;
  onDiscard?: () => void;
}

export const OutOfDateAlert: React.FC<OutOfDateAlertProps> = ({
  fundFamilyId,
  fundFamilyEventId,
  message,
  onDiscard,
}) => {
  const { t } = useTranslation(["common", "events"]);
  const { showToast } = useToast();
  const { mutateAsync: deleteFundFamilyEvent } = useFundFamilyEventDelete({
    mutation: {
      onSuccess: () => {
        onDiscard?.();
        showToast({ variant: "success", message: t("common:discarded") });
      },
    },
  });

  return (
    <Alert status="error" mb="16px">
      <AlertIcon alignSelf="flex-start" mt="4px">
        <ErrorIcon />
      </AlertIcon>
      <AlertDescription>
        {message}
        {onDiscard ? ` ${t("events:outOfDateDiscard")}` : ""}
      </AlertDescription>
      {onDiscard && (
        <Link
          onClick={async () =>
            await deleteFundFamilyEvent({ fundFamilyId, fundFamilyEventId })
          }
        >
          {t("common:discard")}
        </Link>
      )}
    </Alert>
  );
};
